import './TutorProfileMenu.scss';
import '@szhsin/react-menu/dist/index.css';
import '@szhsin/react-menu/dist/transitions/slide.css';

import { Menu, MenuButton, MenuItem } from '@szhsin/react-menu';
import PropTypes from 'prop-types';
import React from 'react';

import useReportingModal from 'components/modals/ReportingModal';
import useSimpleModal from 'components/modals/SimpleModal';
import { isWebApp } from 'utils/utils';

const TutorProfileMenu = ({ showBlock }) => {
  const reportingModal = useReportingModal();
  const simpleModal = useSimpleModal();

  if (!isWebApp) {
    return null;
  }

  const onBlock = () => {
    simpleModal({
      message: '차단하시겠어요?',
      submitText: '네',
      cancelText: '아니오',
    });
  };

  return (
    <Menu
      className="tutor-profile-menu"
      menuButton={
        <MenuButton className="tutor-profile-menu-btn">...</MenuButton>
      }
      transition
    >
      <MenuItem onClick={reportingModal}>신고</MenuItem>
      {showBlock && <MenuItem onClick={onBlock}>차단</MenuItem>}
    </Menu>
  );
};

TutorProfileMenu.propTypes = {
  showBlock: PropTypes.bool,
};

TutorProfileMenu.defaultProps = {
  showBlock: true,
};

export default TutorProfileMenu;
